import { useRef, useEffect } from "preact/hooks";

export function useMeasureElement(): HTMLDivElement {
    const measureElementRef = useRef<HTMLDivElement | null>(null);

    // Create the element synchronously if it doesn't exist
    if (!measureElementRef.current) {
        const measureElement = document.createElement('div');
        measureElement.style.position = 'fixed';
        measureElement.style.top = '-9999px';
        measureElement.style.left = '-9999px';
        measureElement.style.visibility = 'hidden';
        measureElement.style.whiteSpace = 'pre-wrap';
        measureElement.style.wordWrap = 'break-word';
        measureElement.style.padding = '0';
        measureElement.style.margin = '0';
        measureElement.style.border = '0';
        measureElement.style.pointerEvents = 'none';
        measureElement.style.zIndex = '-1';
        document.body.appendChild(measureElement);

        measureElementRef.current = measureElement;
    }

    useEffect(() => {
        // Cleanup function only
        return () => {
            if (measureElementRef.current) {
                document.body.removeChild(measureElementRef.current);
                measureElementRef.current = null;
            }
        };
    }, []);

    return measureElementRef.current;
}

